import { Component, OnInit } from '@angular/core';
import { CookieHandlerService } from '../../common/services/cookieHandler.service';
import { CommonConstants } from '../../common/utilities/commonConstants';
import { RouteHandlerService } from '../../common/services/routeHandler.service';
import { PaymentStatusService } from 'src/app/paymentReview/paymentStatus.service';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { PaymentService } from 'src/app/payment/payment.service';
import { PersonalDetailsCall } from '../../common/services/personalDetails.service';
import { PlanDetailsService } from '../../common/services/planDetails.service';
import { Formatter } from '../../common/services/formatter';
import { adobe_analytics_service } from '../../common/services/adobe_analytics_service';
import { GoogleAnalyticsService } from './../../common/services/google_analytics.service';
import { SharedService } from 'src/app/common/services/sharedService';
import { ClevertapEventHandlerService } from 'src/app/shared/services/cleverTapHandler.service';
@Component({
  templateUrl: './paymentFailed.template.html',
  styleUrls: ['./paymentFailed.style.scss'],
  providers: [PaymentStatusService, PaymentService]
})
export class PaymentFailedComponent implements OnInit {
  public showLoader = true;
  public PaymentFailObject: Model.PaymentObject;
  public paymentMode: any;
  public paymentStatus: any;
  public errorMsg: any;
  public errorCode: any;
  public emiFlag: boolean;
  public amount;
  public mobileNumber;
  public emailId;
  public loanAmount;
  public quoteDetail;
  public pinCode;
  public systemPaymentId;
  public dob; // For Best match
  public quoteItemDetail: any;
  public planCode: any;
  public aemFragmentInfo: any;
  public summaryData;
  public cashlessHospitalcount;
  public selectedSumAssuredAddOn;
  public selectedSumAssured;
  public totalGrossPremium;
  public variantCode;
  public principalId;
  public disclaimer_msg;
  quoteItemDetailAddon: any;
  payAmount: any;
  stagePercentage;
  cityName;
  bflJourney: any;
  isMobileFlag: string;
  statusCallCount: number = 0;
  applicationId;
  quoteId;
  paymentId;
  paymentRetry: boolean = false;
  fetchPaymentData;

  constructor(
    public formatter: Formatter,
    private _routerService: RouteHandlerService,
    private paymentStatusService: PaymentStatusService,
    private _cookieHandlerService: CookieHandlerService,
    private _sessionStorage: SessionHandlerService,
    private _paymentService: PaymentService,
    private _personalDetailsCall: PersonalDetailsCall,
    private _planDetailsService: PlanDetailsService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _sessionHandlerService: SessionHandlerService,
    private _cleverTapService: ClevertapEventHandlerService
  ) { }

  // On Component Init
  public ngOnInit() {
    this.disclaimer_msg = CommonConstants.DISCLAIMER_TEXT;
    this.applicationId = this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId);
    this.quoteId = this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
    this.variantCode = this._sessionStorage.GetSession(CommonConstants.CookieKeys.variantCode);
    this.paymentId = this._routerService.GetQueryParams(CommonConstants.QueryParamsKeys.paymentId);

    const mainContainerHeight = document.getElementById('main-app-container').style.minHeight = '80vh';

    this.getSummaryDetails((resp) => {
      const applicationId = JSON.parse(this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId));
      this._cookieHandlerService.SetCookie(CommonConstants.CookieKeys.applicationId,
        applicationId, applicationId);
      this.fetchPaymentData = {
        applicationId: applicationId,
        quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
      };
      this.getContentFragment();
      if (this._sessionHandlerService.GetSession('status') == 'expired') {
        this.showLoader = true;
      }
      else {
        this.fetchPaymentStatus(this.fetchPaymentData);
      }
    });

    this.cityName = this._sessionStorage.GetSession(CommonConstants.CookieKeys.cityName);
    this.googleAnalyticRetry();
  }


  // Back Button Click
  public Back() {
    this.showLoader = true;
    this._paymentService.PostCallBack('RetryBack').subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
      if (!mtResponse.errorBean) {
        this.showLoader = false;
        if (mtResponse.nextTaskKey) {
          this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
        }
      }
      this.showLoader = false;
    },
      (error) => {
        console.log(error)
        this.showLoader = false;
      });
  }


  public getContentFragment() {
    this._planDetailsService.getAemDetails().subscribe((res) => {
      console.log(res);
      this.aemFragmentInfo = res.properties.elements;
    });
  }

  private fetchPaymentStatus(requestData: any) {
    this.statusCallCount++;

    this.paymentStatusService
      .FetchPaymentStatus(requestData)
      .subscribe((resp: Model.MTResponse<any>) => {

        const mtPaymentStatusResponse: Model.MTResponse<any> = resp;
        if (mtPaymentStatusResponse.payload !== null) {
          if (!resp.payload) { return; }
          const paymentStatusResp = resp.payload.paymentStatusResponse;
          this.amount = paymentStatusResp.paymentAmount;
          this.paymentMode = paymentStatusResp.paymentMode;
          this.paymentStatus = paymentStatusResp.paymentStatus;
          this.systemPaymentId = paymentStatusResp.systemPaymentId;
          this.emailId = resp.payload.emailId;
          this.mobileNumber = resp.payload.mobileNo;
          this.pinCode = resp.payload.pinCode;
          const payMode = this.paymentMode === 'EMIC' ? 'EMIC' : 'non EMIC';
          this.dob = resp.payload.dateOfBirth; // For Best match
          this.PaymentFailObject = {
            amount: this.payAmount ? this.payAmount : this.amount ? this.amount : null,
            mobileNumber: this.mobileNumber,
            emailId: this.emailId,
            applicationId: JSON.parse(this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId)),
            pinCode: this.pinCode,
            systemPaymentId: this.systemPaymentId
          };
          this.paymentRetry = true;
          if (paymentStatusResp.paymentStatus === 'Success') {
            const inputRequestData = {
              applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
              quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
              personCode: CommonConstants.PersonCodes.Proposer
            };
            this.showLoader = true;
            this._paymentService.paymentStatusSuccessCall(inputRequestData, 'retryPayment')
              .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                if (!mtResponse.errorBean) {
                  this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTaskKey);
                  this._routerService.RouteToNextTask(mtResponse.nextTaskKey, null, null, true);
                } else {
                }
                this.showLoader = false;
              }, (error: any) => {
                this.showLoader = false;
              });
          } else {
            if (this.statusCallCount <= 4) {
              const fetchPaymentData = {
                applicationId: JSON.parse(this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId)),
                quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
              };
              setTimeout(() => {
                this.fetchPaymentStatus(fetchPaymentData);
              }, 2000);
            }
          }
        }
        this.showLoader = false;
      },
        (err) => {
          this.showLoader = false;
        });
  }

  private getSummaryDetails(cb?) {
    if (this._sessionStorage.GetSession('status') == 'expired') {
      this.showLoader = true;
    }
    const data = {
      applicationId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
      quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
    };
    this._personalDetailsCall.GetSummaryService(data).subscribe((resp: ActivitiModel.MTResponse<any>) => {
      if (this._sessionStorage.GetSession('status') != 'expired') {
        this.showLoader = false;
      }

      if (!resp.errors) {
        if (resp.payload) {
          this.summaryData = resp.payload;
          this.quoteDetail = this.summaryData.quoteDetail;
          this.quoteItemDetail = resp.payload.quoteItemDetail.find(element => element.quoteItemType === "PRIMARY");
          this.quoteItemDetailAddon = resp.payload.quoteItemDetail.find(element => element.quoteItemType === "ADDON");
          this.planCode = resp.payload.quoteDetail.productCode;
          this.payAmount = this.quoteDetail.grossPremiumAmount;
          this.stagePercentage = resp.payload.applicationStageResponse.appStagePercentage;

          this.totalGrossPremium = this.summaryData.quoteDetail.grossPremiumAmount;
          this.principalId = this.quoteDetail.principalId;


          if (!!this.summaryData.cashlessHospital && !!this.summaryData.cashlessHospital.cashlessHospitalList) {
            const cashlessHospitalObj =
              this.summaryData.cashlessHospital.cashlessHospitalList.filter(val => val.principalId === this.principalId);

            this.cashlessHospitalcount = cashlessHospitalObj.length > 0 ? cashlessHospitalObj[0].hospitalCount : 0;
          } else {
            this.cashlessHospitalcount = 0;
          }

          this.summaryData.quoteItemDetail.forEach(ele => {
            if (ele.quoteItemType === 'ADDON') {
              this.selectedSumAssuredAddOn = ele.sumassuredamt;
            } else if (ele.quoteItemType === 'PRIMARY') {
              this.selectedSumAssured = ele.sumassuredamt;
            }
          });
          if (cb) {
            cb(resp);
          }
        }
      }
      if (this._sessionStorage.GetSession('status') == 'expired') {
        this.fetchPaymentStatus(this.fetchPaymentData);
      }

    }, (error: any) => {
      this.showLoader = false;
    });
  }

  public googleAnalyticRetry() {

    let partnerName = '';
    let partnerPlanName = '';

    let planVariant = '';

    planVariant = this.summaryData.quoteItemDetail.find(element => element.quoteItemType === 'PRIMARY').productVariantCode;

    if (!!this.aemFragmentInfo) {
      partnerPlanName =
        this.aemFragmentInfo.productName.variations[this.planCode.toLowerCase() + '_' + planVariant.toLowerCase()].value;

      partnerName =
        this.aemFragmentInfo.principleName.variations[this.planCode.toLowerCase() + '_' + planVariant.toLowerCase()].value;
    }

    this._googleAnalyticsService.pushToDataLayer({
      'event': 'button_click',
      'pageType': 'Transaction Failed Page',            //E.g. Product Listing Page, Product Detail Page
      'productId': 'HGI',                   //E.g. HGI
      'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
      'partnerName': partnerName,
      'partnerPlanName': partnerPlanName,
      'premiumAmount': `Rs.${this.formatter.ToCurrency(this.totalGrossPremium.toString())}`,
      'sumInsured': `Rs.${this.formatter.ConvertNumberToAmount(this.selectedSumAssured.toString())}`,   //E.g. 5 Lac, 6 Lac, etc.
      'tenure': `${this.quoteItemDetail.tenure} Year`,
      'section': 'Transaction Failed',         //E.g. Tenure, Insured Member Details, etc.
      'paymentMethod': this.summaryData.paymentDetail.paymentMode,
      'clickText': 'Retry Payment',
      'mobile': this.summaryData.apllicationDetail.mobileNumber,
      'dob': this.summaryData.quoteCriteriaDetail.hGIQuoteCriteria.insuranceDetails.dobProposal,
      'insuringFor': this.summaryData.quoteCriteriaDetail.hGIQuoteCriteria.insuranceDetails.insuringFor,
      'pinCode': this.pinCode,
      'city': this.cityName ? this.cityName : '',
      'appQuoteCriteriaId': this.summaryData.appQuoteCriteriaId,
      'stagePercentage': this.stagePercentage,
      'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
    });
  }
  public cleverTapPayloadPaymentStatus(ctaName) {

    let partnerName = '';

    let planVariant = '';
    if (this.summaryData && this.summaryData.quoteItemDetail) {
      planVariant = this.summaryData.quoteItemDetail.find(element => element.quoteItemType === 'PRIMARY').productVariantCode;

      if (!!this.aemFragmentInfo) {

        partnerName =
          this.aemFragmentInfo.principleName.variations[this.planCode.toLowerCase() + '_' + planVariant.toLowerCase()].value;
      }

      //MobileNumber fetched from the session storage
      let mobileDataFromSession;
      mobileDataFromSession = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.planQuoteCriteriaData);
      let mobileNumber = JSON.parse(mobileDataFromSession).mobile;

      this._cleverTapService.clevertapPwaEvents("INSURANCE_PWA_VIEWED",
        {
          "EP_INSURANCE_PRODUCTCODE": partnerName,
          "EP_INSURANCE_PAGE": "HEALTH_TRANSACTION_STATUS",
          "EP_PAYMENT_STATUS": this.paymentStatus,
          "EP_INSURANCE_OFFERS": partnerName,
          "EP_INSURANCE_QUOTE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId),
          "EP_PAYMENT_INSTRUMENT": this.summaryData.paymentDetail.paymentMode,
          "EP_TXN_ID": this.systemPaymentId,
          "EP_AMOUNT": this.amount,
          "EP_MOBILE": mobileNumber,
          "EP_CTA": ctaName
        })

    }

  }


}
